import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { AdminProvider } from './contexts/AdminContext';
import AdminLoginModal from './components/admin/AdminLoginModal';
import AdminToolbar from './components/admin/AdminToolbar';

import './App.css';

import Homepage from './components/Homepage';
import About from './components/About';
import VideoPlayer from './components/VideoPlayer';
import ScrollToTop from './components/utils/ScrollToTop';
import GetInTouchForm from './components/GetInTouchForm';
import SubmitForm from './components/SubmitForm';
import OrganisationsPage from './components/library/OrganisationsPage';
import MaterialsPage from './components/library/MaterialsPage';
import MaterialDetail from './components/library/MaterialDetail';
import OrgDetail from './components/library/OrgDetail';
import IncidentsPage from './components/library/IncidentsPage';
import IncidentDetail from './components/library/IncidentDetail';
import MailSignUpForm from './components/MailSignUpForm';

import ClaimPage from './components/ClaimPage';


// Legacy redirect helpers for old /library/* URLs
function LibraryOrgRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/organisations/${slug}`} replace />;
}
function LibraryMaterialRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/materials/${slug}`} replace />;
}

const App = () => {
    return (
    <>
    <HelmetProvider>
          <AdminProvider>
            <Router>
                <VideoPlayer />
                <ScrollToTop />
                <AdminLoginModal />
                <AdminToolbar />
                <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/about" element={<About />} />

                {/* New consolidated forms */}
                <Route path="/contact" element={<GetInTouchForm />} />
                <Route path="/submit" element={<SubmitForm />} />

                {/* Legacy form redirects */}
                <Route path="/volunteer" element={<Navigate to="/contact" replace />} />
                <Route path="/submit-claim" element={<Navigate to="/submit" replace />} />
                <Route path="/report" element={<Navigate to="/submit" replace />} />
                {/* Standalone listing pages */}
                <Route path="/organisations" element={<OrganisationsPage />} />
                <Route path="/organisations/:slug" element={<OrgDetail />} />
                <Route path="/materials" element={<MaterialsPage />} />
                <Route path="/materials/:slug" element={<MaterialDetail />} />
                <Route path="/incidents" element={<IncidentsPage />} />
                <Route path="/incidents/:slug" element={<IncidentDetail />} />

                {/* Legacy redirects — keep old /library URLs working */}
                <Route path="/library" element={<Navigate to="/organisations" replace />} />
                <Route path="/library/organisations/:slug" element={<LibraryOrgRedirect />} />
                <Route path="/library/materials/:slug" element={<LibraryMaterialRedirect />} />
                <Route path="/sign-up" element={<MailSignUpForm />} />

                {/* Dynamic claim pages — all claim URLs use ClaimPage with :slug */}
                {/* Short URLs */}
                <Route path="/church" element={<ClaimPage />} />
                <Route path="/captives" element={<ClaimPage />} />
                <Route path="/elderly" element={<ClaimPage />} />

                {/* Primary claim slugs (match D1 slugs) */}
                <Route path="/forty-beheaded-babies" element={<ClaimPage />} />
                <Route path="/al-ahli-attacked" element={<ClaimPage />} />
                <Route path="/al-shifa-fuel" element={<ClaimPage />} />
                <Route path="/makeup" element={<ClaimPage />} />
                <Route path="/hamas-chemical-weapons" element={<ClaimPage />} />
                <Route path="/israel-denies-church-killing" element={<ClaimPage />} />
                <Route path="/israeli-soldier-helps" element={<ClaimPage />} />
                <Route path="/palestinian-captives-stripped" element={<ClaimPage />} />
                <Route path="/unrwa-is-infiltrated-by-hamas" element={<ClaimPage />} />

                {/* Legacy backward-compatible URLs */}
                <Route path="/captives-stripped" element={<ClaimPage />} />
                <Route path="/israel-helps-elderly-man" element={<ClaimPage />} />
                <Route path="/israeli-state-denies" element={<ClaimPage />} />
                <Route path="/claim" element={<ClaimPage />} />
                </Routes>
            </Router>
          </AdminProvider>
    </HelmetProvider>
    </>
  );  
}

export default App;
